export const COLOR_PALETTE = [
  { id: 'red',    label: 'Red',    rgb: { R: 220, G: 38,  B: 38,  A: 1 } },
  { id: 'black',  label: 'Black',  rgb: { R: 17,  G: 17,  B: 17,  A: 1 } },
  { id: 'yellow', label: 'Yellow', rgb: { R: 255, G: 214, B: 10,  A: 1 } },
  { id: 'blue',   label: 'Blue',   rgb: { R: 37,  G: 99,  B: 235, A: 1 } },
  { id: 'green',  label: 'Green',  rgb: { R: 16,  G: 185, B: 129, A: 1 } },
];

export const CONTRACT_TOOLS = [
  {
    id: 'pen',
    label: 'Pen',
    toolName: 'AnnotationCreateFreeHand',
    defaultColor: 'red',
    defaultThickness: 2,
    defaultOpacity: 1,
    filled: false,
  },
  {
    id: 'highlighter',
    label: 'Highlighter',
    toolName: 'AnnotationCreateFreeHandHighlight',
    defaultColor: 'yellow',
    defaultThickness: 18,
    defaultOpacity: 0.45,
    filled: false,
  },
  {
    id: 'square',
    label: 'Square',
    toolName: 'AnnotationCreateRectangle',
    defaultColor: 'red',
    defaultThickness: 3,
    defaultOpacity: 1,
    filled: false,
  },
  {
    id: 'circle',
    label: 'Circle',
    toolName: 'AnnotationCreateEllipse',
    defaultColor: 'red',
    defaultThickness: 3,
    defaultOpacity: 1,
    filled: false,
  },
  {
    id: 'arrow',
    label: 'Arrow',
    toolName: 'AnnotationCreateArrow',
    defaultColor: 'red',
    defaultThickness: 3,
    defaultOpacity: 1,
    filled: false,
  },
];

export const DEFAULT_FADE_SECONDS = 5;
export const MIN_THICKNESS = 1;
export const MAX_THICKNESS = 40;

export function getToolById(id) {
  return CONTRACT_TOOLS.find((t) => t.id === id);
}

export function getColorById(id) {
  return COLOR_PALETTE.find((c) => c.id === id) || COLOR_PALETTE[0];
}
